import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, NavigationEnd, Router } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { NavigationService } from '../services/navigation.service';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { FloatingContactMenu } from '../components/shared/floating-contact-menu/floating-contact-menu';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSonnerToaster, FloatingContactMenu],
  template: `
    <router-outlet></router-outlet>
    <allas-floating-contact-menu />
    <ngx-sonner-toaster richColors />
  `,
  providers: [NavigationService],
})
export class App implements OnInit {
  private navigationService = inject(NavigationService);
  private router = inject(Router);
  private document = inject(DOCUMENT);
  private readonly CANONICAL_DOMAIN = 'https://www.allasrepuestos.com';

  ngOnInit() {
    this.updateCanonicalUrl();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCanonicalUrl();
      });
  }

  private updateCanonicalUrl() {
    const currentRoute = this.router.url;
    const canonicalUrl = `${this.CANONICAL_DOMAIN}${currentRoute}`;

    const head = this.document.head;
    let element: HTMLLinkElement | null = this.document.querySelector(
      `link[rel='canonical']`
    );

    if (element) {
      element.setAttribute('href', canonicalUrl);
    } else {
      element = this.document.createElement('link');
      element.setAttribute('rel', 'canonical');
      element.setAttribute('href', canonicalUrl);
      head.appendChild(element);
    }
  }
}
